export const INPUT_TYPES = {
  TEXTAREA: "textarea",
  TEXT: "text",
  EMAIL: "email",
  NUMBER: "number",
  DATE: "date",
  SELECT: "select",
  TEL: "tel",
  PASSWORD: "password"
};